//export const BASE_URL = "http://127.0.0.1:8000";
export const BASE_URL = "https://api.neginbasparshargh.com";
export const FRONT_URL = "https://neginbasparshargh.com";
//export const FRONT_URL = "http://127.0.0.1:3000";
export const API_VERSION = "api/v1"
export const SANDBOX = "sandbox."
//export const SANDBOX = ""
